function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Observable } from 'relay-runtime';
import io from 'socket.io-client';
export var SocketIoSubscriptionClient =
/*#__PURE__*/
function () {
  function SocketIoSubscriptionClient(_temp) {
    var _this = this;

    var _ref = _temp === void 0 ? {} : _temp,
        token = _ref.token,
        _ref$url = _ref.url,
        url = _ref$url === void 0 ? '/socket.io/graphql' : _ref$url,
        _ref$maxSubscriptions = _ref.maxSubscriptions,
        maxSubscriptions = _ref$maxSubscriptions === void 0 ? 200 : _ref$maxSubscriptions;

    this.nextSubscriptionId = 0;
    this.subscriptions = new Map();
    this.maxSubscriptions = maxSubscriptions;
    var origin, path;

    try {
      var parsed = new URL(url);
      origin = parsed.origin;
      path = parsed.pathname;
    } catch (err) {
      origin = window.location.origin;
      path = url;
    }

    var socket = io(origin, {
      path: path,
      transports: ['websocket']
    });
    this.socket = socket;
    socket.on('connect', function () {
      if (token) {
        _this.emitTransient('authenticate', token);
      }

      _this.subscriptions.forEach(function (subscription, id) {
        _this.emitSubscribe(id, subscription);
      });
    }).on('subscription update', function (_ref2) {
      var id = _ref2.id,
          payload = _objectWithoutPropertiesLoose(_ref2, ["id"]);

      var subscription = _this.subscriptions.get(id);

      if (!subscription) {
        return;
      }

      subscription.sink.next(payload);
    });
  }

  var _proto = SocketIoSubscriptionClient.prototype;

  _proto.subscribe = function subscribe(operation, variables) {
    var _this2 = this;

    return Observable.create(function (sink) {
      var id = _this2.nextSubscriptionId++;

      if (_this2.subscriptions.size >= _this2.maxSubscriptions) {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn('subscription limit reached');
        }

        return undefined;
      }

      var subscription = {
        sink: sink,
        query: operation.text,
        variables: variables
      };

      _this2.subscriptions.set(id, subscription);

      _this2.emitSubscribe(id, subscription);

      return function () {
        _this2.emitTransient('unsubscribe', id);

        _this2.subscriptions.delete(id);
      };
    });
  };

  _proto.close = function close() {
    this.socket.disconnect();
    this.subscriptions.forEach(function (_ref3) {
      var sink = _ref3.sink;
      sink.complete();
    });
  };

  _proto.emitTransient = function emitTransient(event) {
    var _this$socket;

    // For transient state management, we re-emit on reconnect anyway, so no
    // need to use the send buffer.
    if (!this.socket.connected) {
      return;
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    (_this$socket = this.socket).emit.apply(_this$socket, [event].concat(args));
  };

  _proto.emitSubscribe = function emitSubscribe(id, _ref4) {
    var query = _ref4.query,
        variables = _ref4.variables;
    this.emitTransient('subscribe', {
      id: id,
      query: query,
      variables: variables
    });
  };

  return SocketIoSubscriptionClient;
}();
export default function createSubscribe(_temp2) {
  var _ref5 = _temp2 === void 0 ? {} : _temp2,
      _ref5$subscriptionCli = _ref5.subscriptionClientClass,
      subscriptionClientClass = _ref5$subscriptionCli === void 0 ? SocketIoSubscriptionClient : _ref5$subscriptionCli,
      options = _objectWithoutPropertiesLoose(_ref5, ["subscriptionClientClass"]);

  // eslint-disable-next-line new-cap
  var subscriptionClient = new subscriptionClientClass(options);

  function subscribeFn(operation, variables) {
    return subscriptionClient.subscribe(operation, variables);
  }

  subscribeFn.client = subscriptionClient;

  subscribeFn.close = function () {
    var _subscriptionClient$c;

    (_subscriptionClient$c = subscriptionClient.close) === null || _subscriptionClient$c === void 0 ? void 0 : _subscriptionClient$c.call(subscriptionClient);
  };

  return subscribeFn;
}